module.exports = __webpack_public_path__ + "272bb65c7fc66b08348592bcf3cff9c7.png";